var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:({ fontSize: _vm.fontSize + 'em' })},[_c('v-main',{staticClass:"body"},[_c('v-main',{staticClass:"pa-0"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }